import styled from 'styled-components';
import { VisualPickerButtonContainer } from '../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';

export const GoalTileButton = styled(VisualPickerButtonContainer)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: 12,
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  height: '100%',
});
